import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('securityProfiles');

export const check = () => useBasicAuth.checkToken();

export const findSecurityProfileById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSecurityProfile = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSecurityProfileByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllSecurityProfileByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addSecurityProfile = (obj) => 
  axios.post(urlAPI + "/addSecurityProfile" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateSecurityProfile = (obj) => 
  axios.put(urlAPI + "/updateSecurityProfile/" + obj.securityProfile.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteSecurityProfile = (id) => 
  axios.delete(urlAPI + "/deleteSecurityProfile/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



export const findAllBySecurityProfileKey_profile = (securityProfile) => 
  axios.post(urlAPI + "/securityProfileKey/profile", JSON.stringify(securityProfile), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllBySecurityProfileKey_key = (securityKey) => 
  axios.post(urlAPI + "/securityProfileKey/key", JSON.stringify(securityKey), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });